import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import ContactCard from './utils/ContactCard';
import '../App.css';

const EMAIL = 'aastrogai@gmail.com';
const WHATSAPP_NUMBER = '918866822366';
const SOCIAL_LINKS = [
    {
        href: 'https://facebook.com/aastroga',
        iconClass: 'fa-brands fa-facebook',
        label: 'Facebook',
    },
    {
        href: 'https://instagram.com/aastrogai',
        iconClass: 'fa-brands fa-instagram',
        label: 'Instagram',
    },
    {
        href: 'https://x.com/aastrogai',
        iconClass: 'fa-brands fa-x-twitter',
        label: 'X',
    },
];

function SocialLinks({ links }) {
    return (
        <div className="socialLinks">
            {links.map(({ href, iconClass, label }) => (
                <a
                    href={href}
                    key={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="socialLink" 
                    aria-label={label}
                >
                    <i className={iconClass}></i>
                </a>
            ))}
        </div>
    );
}

SocialLinks.propTypes = {
    links: PropTypes.arrayOf(
        PropTypes.shape({
            href: PropTypes.string.isRequired,
            iconClass: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
        })
    ).isRequired,
};

function ContactUs() {
    const navigate = useNavigate();

    const handleFeedbackClick = () => navigate('/feedback');
    const handleWhatsAppClick = () =>
        window.open(`https://wa.me/${WHATSAPP_NUMBER}`, '_blank');

    return (
        <div className="container"> 
            <h1 className="heading">Contact Us</h1> 
            <p className="refer-subtitle"> 
                We'd love to hear from you! Reach out to us through any of the following channels:
            </p>

            {/* Email */}
            <a
                href={`mailto:${EMAIL}`}
                className="link" 
                aria-label="Email Us"
            >
                <ContactCard
                    icon="📧"
                    label="Email Us"
                    content={EMAIL}
                    tabIndex={-1}
                />
            </a>

            {/* Feedback */}
            <ContactCard
                icon="💬"
                label="Feedback"
                content="Share your feedback"
                onClick={handleFeedbackClick}
                role="button"
                tabIndex={0}
            />

            {/* WhatsApp */}
            <ContactCard
                icon={<i className="fa-brands fa-whatsapp" style={{ fontSize: '1.5rem', color: '#fff' }}></i>}
                label="WhatsApp"
                content="Chat on WhatsApp"
                onClick={handleWhatsAppClick}
                role="button"
                tabIndex={0}
                cardHoverColor="#25D366"
            />

            {/* Social Media */}
            <div className="socialSection"> 
                <p className="refer-subtitle">Follow us on social media:</p> 
                <SocialLinks links={SOCIAL_LINKS} />
            </div>

            <hr className="divider" /> 

            <p className="refer-subtitle">AastroG your personal Astro Guru</p> 
        </div>
    );
}

export default ContactUs;